import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import styled, { css } from 'styled-components';
import { InfoCardsSection } from './InfoCardsSection';
import Section from './Section';
import { ECLIPSE, OATMILK } from 'developer-docs-shared-components/config/cssConstants';
import { mediaQueries } from 'developer-docs-shared-components/utils/mediaQueries';
import I18n from 'I18n';
import UIFlex from 'UIComponents/layout/UIFlex';
import useMetadata from 'developer-docs-shared-components/hooks/useMetadata';
import { useEffect } from 'react';
import LayoutPublic from '../../components/LayoutPublic';
import { apiGuidesNavConfig } from '../../config/nav/guides/apiGuides';
import { appsNavConfig } from '../../config/nav/guides/apps';
import { cmsDevelopmentNavConfig } from '../../config/nav/guides/cmsDevelopment';
import { crmCustomizationNavConfig } from '../../config/nav/guides/crmCustomization';
import { apiEndpointsNavConfig } from '../../config/nav/reference/apiEndpoints';
import { cmsReferenceNavConfig } from '../../config/nav/reference/cmsReference';
import { uiComponentsNavConfig } from '../../config/nav/reference/uiComponents';
import { getLocalizedBadge } from '../../utils/localization';
import { getUsageTracker } from '../../utils/usage-tracker';
import MainLandingFooter from './MainLandingFooter';
import WhatsNew from './WhatsNew';
import { DeveloperDocsHeader } from './DeveloperDocsHeader';
import { MorseCode } from './morse-code/MorseCode';
import QueensFontStyles from './QueensFontStyles';
import { NavMarker } from 'react-rhumb';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mainElStyleOverrides = css(["padding-left:0;padding-right:0;padding-bottom:0;padding-top:0;& > div > div{padding-top:0;}"]);
const HeaderWrapper = styled.div.withConfig({
  displayName: "MainLandingPage__HeaderWrapper",
  componentId: "kttcvn-0"
})(["background-color:", ";overflow:hidden;"], ECLIPSE);
const HeaderWidth = styled(UIFlex).withConfig({
  displayName: "MainLandingPage__HeaderWidth",
  componentId: "kttcvn-1"
})(["max-width:1126px;"]);
const IllustrationWrapper = styled.div.withConfig({
  displayName: "MainLandingPage__IllustrationWrapper",
  componentId: "kttcvn-2"
})(["display:flex;justify-content:center;"]);
const MobileDisplay = styled.div.withConfig({
  displayName: "MainLandingPage__MobileDisplay",
  componentId: "kttcvn-3"
})(["", "{display:none;}"], mediaQueries.aboveTablet);
const DesktopDisplay = styled.div.withConfig({
  displayName: "MainLandingPage__DesktopDisplay",
  componentId: "kttcvn-4"
})(["", "{display:none;}display:flex;justify-content:center;"], mediaQueries.belowTablet);
export const MainLandingPage = () => {
  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: 'mainLandingPage',
      subscreen: 'mainLandingPage'
    });
  }, []);
  useMetadata({
    title: I18n.text('developer-docs-ui.htmlTitle'),
    description: I18n.text('developer-docs-ui.metaDescriptions.mainLanding'),
    isContentLoaded: true
  });
  return /*#__PURE__*/_jsx(LayoutPublic, {
    maxContentWidth: null,
    FooterComponent: MainLandingFooter,
    sideNavComponent: null,
    footerWidth: "full",
    mainStyles: mainElStyleOverrides,
    showFeedbackForm: false,
    children: /*#__PURE__*/_jsxs(NavMarker, {
      name: "MAIN_LANDING_PAGE_LOAD",
      children: [/*#__PURE__*/_jsx(QueensFontStyles, {}), /*#__PURE__*/_jsxs("div", {
        "data-test-id": "MAIN_LANDING_PAGE",
        children: [/*#__PURE__*/_jsxs(HeaderWrapper, {
          children: [/*#__PURE__*/_jsx(MobileDisplay, {
            children: /*#__PURE__*/_jsxs(Section, {
              background: ECLIPSE,
              children: [/*#__PURE__*/_jsx(IllustrationWrapper, {
                children: /*#__PURE__*/_jsx(UIIllustration, {
                  loading: "lazy",
                  name: "documentation",
                  width: 150,
                  alt: I18n.text('developer-docs-ui.accessibility.mainLandingIllustrationAltText')
                })
              }), /*#__PURE__*/_jsx(DeveloperDocsHeader, {})]
            })
          }), /*#__PURE__*/_jsx(DesktopDisplay, {
            children: /*#__PURE__*/_jsxs(HeaderWidth, {
              children: [/*#__PURE__*/_jsx(DeveloperDocsHeader, {}), /*#__PURE__*/_jsx(MorseCode, {})]
            })
          })]
        }), /*#__PURE__*/_jsx(InfoCardsSection, {
          headerIcon: "code",
          header: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-ui.mainLandingPage.referenceDocs.header"
          }),
          background: OATMILK,
          cards: [{
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.mainLandingPage.referenceDocs.cards.apiEndpoints.header"
            }),
            content: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.mainLandingPage.referenceDocs.cards.apiEndpoints.content"
            }),
            link: {
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-ui.mainLandingPage.referenceDocs.cards.apiEndpoints.link"
              }),
              url: `${apiEndpointsNavConfig().commonPath}`
            }
          }, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.mainLandingPage.referenceDocs.cards.cmsReference.header"
            }),
            content: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.mainLandingPage.referenceDocs.cards.cmsReference.content"
            }),
            link: {
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-ui.mainLandingPage.referenceDocs.cards.cmsReference.link"
              }),
              url: `${cmsReferenceNavConfig().commonPath}`
            }
          }, {
            title: /*#__PURE__*/_jsxs(UIFlex, {
              align: "center",
              children: [/*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-ui.mainLandingPage.referenceDocs.cards.uiComponents.header"
              }), /*#__PURE__*/_jsx(View, {
                marginInlineStart: "200",
                as: "span",
                children: getLocalizedBadge('BETA')
              })]
            }),
            content: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.mainLandingPage.referenceDocs.cards.uiComponents.content"
            }),
            link: {
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-ui.mainLandingPage.referenceDocs.cards.uiComponents.link"
              }),
              url: `${uiComponentsNavConfig().commonPath}`
            }
          }]
        }), /*#__PURE__*/_jsx(WhatsNew, {}), /*#__PURE__*/_jsx(InfoCardsSection, {
          background: OATMILK,
          headerIcon: "bulb",
          header: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-ui.mainLandingPage.guides.header"
          }),
          cards: [{
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.mainLandingPage.guides.cards.apiGuides.header"
            }),
            content: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.mainLandingPage.guides.cards.apiGuides.content"
            }),
            link: {
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-ui.mainLandingPage.guides.cards.apiGuides.link"
              }),
              url: `${apiGuidesNavConfig().commonPath}`
            }
          }, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.mainLandingPage.guides.cards.apps.header"
            }),
            content: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.mainLandingPage.guides.cards.apps.content"
            }),
            link: {
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-ui.mainLandingPage.guides.cards.apps.link"
              }),
              url: `${appsNavConfig().commonPath}`
            }
          }, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.mainLandingPage.guides.cards.cmsDevelopment.header"
            }),
            content: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.mainLandingPage.guides.cards.cmsDevelopment.content"
            }),
            link: {
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-ui.mainLandingPage.guides.cards.cmsDevelopment.link"
              }),
              url: `${cmsDevelopmentNavConfig().commonPath}`
            }
          }, {
            title: /*#__PURE__*/_jsxs(UIFlex, {
              align: "center",
              children: [/*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-ui.mainLandingPage.guides.cards.uiCustomization.header"
              }), /*#__PURE__*/_jsx(View, {
                marginInlineStart: "200",
                as: "span",
                children: getLocalizedBadge('BETA')
              })]
            }),
            content: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.mainLandingPage.guides.cards.uiCustomization.content"
            }),
            link: {
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-ui.mainLandingPage.guides.cards.uiCustomization.link"
              }),
              url: `${crmCustomizationNavConfig().commonPath}`
            }
          }]
        })]
      })]
    })
  });
};